module.exports = __webpack_public_path__ + "img/outline_check.c630fcf6.svg";